import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/useLanguage";

const VisitUsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-gradient-to-b from-secondary to-background py-8 lg:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-[40px] font-bold text-primary text-center mb-10">
          {t("visit.heading")}
        </h2>
        <div className="grid md:grid-cols-2 gap-6 items-stretch">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-lg ring-1 ring-border h-[400px]">
            <iframe
              title={t("visit.iframeTitle")}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2000!2d10.7522!3d59.9148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTnCsDU0JzUzLjMiTiAxMMKwNDUnMDcuOSJF!5e0!3m2!1sno!2sno!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info card */}
          <div className="bg-card rounded-2xl shadow-lg ring-1 ring-border p-8 md:p-10 flex flex-col justify-center">
            <h3 className="text-xl md:text-2xl font-bold text-foreground mb-6">
              {t("visit.title")}
            </h3>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-foreground">{t("visit.address")}</p>
                  <p className="text-muted-foreground text-sm">{t("visit.addressValue")}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-foreground">{t("visit.hours")}</p>
                  <p className="text-muted-foreground text-sm">{t("visit.hoursValue")}</p>
                </div>
              </div>
            </div>

            <Link to="/get-quote">
              <Button className="w-full sm:w-auto bg-[#1B2A4A] text-white hover:bg-[#1B2A4A]/90 rounded-xl px-8 py-6 text-base font-semibold">
                {t("visit.cta")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitUsSection;
